import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ClimbingBoxLoader } from 'react-spinners';
import { IoLocationSharp } from "react-icons/io5";

export const YourRooms = () => {
  const navigate = useNavigate();
  const [rooms, setRooms] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [roomToDelete, setRoomToDelete] = useState(null);

  const handleViewMore = (roomId) => {
    navigate(`/room/${roomId}`);
  };

  const handleEdit = (roomId) => {
    // Redirect to the edit page with the room ID
    navigate(`/edit-room/${roomId}`);
  };

  const handleDelete = (roomId) => {
    // Show the delete confirmation modal
    setShowDeleteModal(true);
    setRoomToDelete(roomId);
  };
  useEffect(() => {
    if (localStorage.getItem('email') == null && localStorage.getItem('password') == null) {
      navigate('/login');
    }
  }, []);

  const confirmDelete = async () => {
    try {
      // Add logic to show a confirmation dialog before deleting if needed
      await fetch(`https://pgdost.onrender.com/api/rooms/${roomToDelete}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      // Fetch updated list of rooms
      const response = await fetch(`https://pgdost.onrender.com/api/user-rooms?email=${localStorage.getItem('email')}`);
      const data = await response.json();
      setRooms(data.rooms);

      // Hide the delete confirmation modal
      setShowDeleteModal(false);
      setRoomToDelete(null);
    } catch (error) {
      console.error('Error deleting room:', error);
    }
  };

  const cancelDelete = () => {
    // Hide the delete confirmation modal
    setShowDeleteModal(false);
    setRoomToDelete(null);
  };

  useEffect(() => {
    // Fetch data from your API
    fetch(`https://pgdost.onrender.com/api/user-rooms?email=${localStorage.getItem('email')}`)
      .then((response) => response.json())
      .then((data) => setRooms(data.rooms))
      .catch((error) => console.error('Error fetching rooms:', error));
  }, []);

  const handleMenuToggle = (roomId) => {
    setSelectedRoom(selectedRoom === roomId ? null : roomId);
  };

  return (
    <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-8 mt-24 ml-6 mr-6 '>
      {rooms.length === 0 ? (
        <div className="w-full flex items-center justify-center h-64 text-3xl sm:ml-96  ">
         No Room Posted Yet :(
        
        
      </div>
      ) : (
        rooms.map((room) => (
          <div key={room._id} className="relative w-full max-w-md bg-white border border-gray-200 rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700 mx-auto">
            <a href="#">
              <img
                className="w-full h-40 object-cover rounded-t-lg"
                src={room.photos[0]} // Use the base64 string directly
                alt="product image"
              />
            </a>
            <div className="px-6 py-4">
              <a href="#">
                <h5 className="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">{room.pgName}</h5>
              </a>
              <div className="flex items-center mt-2.5 mb-4 space-x-2">
              <div className="flex items-center mt-2.5 mb-4 space-x-2">
                  <IoLocationSharp />
                  <span className="font-bold text-gray-500">
                    {room.locationurl.length > 20
                      ? room.locationurl.substring(0, 20) + '...'
                      : room.locationurl}
                  </span>
                  </div>
                <div className="relative inline-block text-left">
                  <div>
                    <button
                      onClick={() => handleMenuToggle(room._id)}
                      type="button"
                      className="inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm dark:bg-gray-800 dark:border-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-500"
                    >
                      <svg
                        className="w-5 h-5"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M4 6h16M4 12h16m-7 6h7"
                        />
                      </svg>
                    </button>
                  </div>
                  {selectedRoom === room._id && (
                    <div
                      className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="options-menu"
                    >
                      <div className="py-1" role="none">
                        <button
                          onClick={() => {
                            handleEdit(room._id);
                            handleMenuToggle(room._id);
                          }}
                          className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 w-full"
                          role="menuitem"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => handleDelete(room._id)}
                          className="block px-4 py-2 text-sm text-red-700 hover:bg-red-100 hover:text-red-900 w-full"
                          role="menuitem"
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-3xl font-bold text-gray-900 dark:text-white">₹{room.roomRent}/month</span>
                <a
                  href=""
                  className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  onClick={() => handleViewMore(room._id)}
                >
                  See More
                </a>
              </div>
            </div>
          </div>
        ))
      )}
      
      {showDeleteModal && (
        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 transition-opacity" aria-hidden="true">
              <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                    {/* Heroicon name: exclamation */}
                    <svg className="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6-6h12a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2v-8a2 2 0 012-2z"></path>
                    </svg>
                  </div>
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <h3 className="text-lg leading-6 font-medium text-gray-900">Delete Room</h3>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        Are you sure you want to delete this room? This action cannot be undone.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button onClick={confirmDelete} type="button" className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm">
                  Delete
                </button>
                <button onClick={cancelDelete} type="button" className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
